import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTables } from '../../services/api';
import './DockWidgets.css';

const TablesWidget = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTables();
    const interval = setInterval(loadTables, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const loadTables = async () => {
    try {
      const data = await getTables();
      setTables(data.tables || []);
    } catch (error) {
      console.error('Error loading tables:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTableStatus = (table) => {
    if (!table.isActive) return 'inactive';
    if (table.currentOrderId) return 'occupied';
    return 'free';
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'free':
        return 'table-free';
      case 'occupied':
        return 'table-occupied';
      case 'inactive':
        return 'table-inactive';
      default:
        return '';
    }
  };

  const stats = {
    total: tables.length,
    free: tables.filter((t) => t.isActive && !t.currentOrderId).length,
    occupied: tables.filter((t) => t.isActive && t.currentOrderId).length,
    inactive: tables.filter((t) => !t.isActive).length,
  };

  if (loading) {
    return (
      <div className="widget-loading">
        <span className="material-icons spinning">sync</span>
      </div>
    );
  }

  return (
    <div className="tables-widget">
      {tables.length === 0 ? (
        <div className="widget-empty">
          <span className="material-icons">table_restaurant</span>
          <span>{t('dock.noTables', 'Sin mesas configuradas')}</span>
        </div>
      ) : (
        <>
          <div className="tables-grid">
            {tables.slice(0, 12).map((table) => {
              const status = getTableStatus(table);
              return (
                <div
                  key={table.tableId}
                  className={`table-cell ${getStatusClass(status)}`}
                  title={`${t('common.table', 'Mesa')} ${table.tableNumber} - ${status}`}
                >
                  {table.tableNumber}
                </div>
              );
            })}
          </div>

          <div className="tables-stats">
            <span className="stat-item free">
              <span className="stat-dot"></span>
              {t('dock.free', 'Libres')}: {stats.free}
            </span>
            <span className="stat-item occupied">
              <span className="stat-dot"></span>
              {t('dock.occupied', 'Ocupadas')}: {stats.occupied}
            </span>
          </div>

          <button type="button" className="widget-action" onClick={() => navigate('/tables')}>
            {t('dock.viewAll', 'Ver todas')}
            <span className="material-icons">arrow_forward</span>
          </button>
        </>
      )}
    </div>
  );
};

export default TablesWidget;
